import { useContext, useState } from 'react';
import { store } from 'components/Store';
import { ReportsPopup } from 'components/Dashboard/Navigation/NotFeaturePopups';
import { useAuth0 } from '@auth0/auth0-react';
import useTopicOrClientWord from 'components/Dashboard/hooks/useTopicOrClientWord';
import AddUpdatesToReport from 'components/Dashboard/SubNav/ui/AddUpdatesToReport';
import { useSiteSectionsNames } from 'utils/getAppSite';

const CreateReportFromUpdate = (props) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { activePlan } = state;
  const { enableReports } = activePlan;
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenReportPopup, setIsOpenReportPopup] = useState(false);

  const { currentNew, show, userContentPage } = props;

  const { embargoed, objectType } = currentNew ?? {};
  const resourceWord = objectType === 'CrmInteraction' ? 'interaction' : 'update';
  const { isAuthenticated } = useAuth0();

  const notEnableReports = !enableReports && isAuthenticated;
  const { agencyUser } = useTopicOrClientWord();
  const { getName } = useSiteSectionsNames();

  return (
    <>
      {show && !agencyUser && (
        <div
          className={`py-3 pl-3 ${
            userContentPage ? '' : 'pr-3'
          } mb-3 box-rounded box-outstanding-reports bg-white related-content-create-report-from-update`}
        >
          <h3
            className={`${userContentPage ? 'paragraph-p2' : 'font-weight-bold'} flex-centered justify-content-between`}
          >
            <span>Add to a report</span>{' '}
            <span
              className='icon-info'
              data-tooltip-content={`Create a PDF report with this ${resourceWord}, and ${getName({ property: 'customise' })} it with your commentary and other political content or analysis`}
              data-tooltip-id='general-tooltip'
              data-tooltip-class-name={'general-tooltip pricing-feature-tooltip report-popup-tooltip'}
            />
          </h3>
          <button
            className={`w-100 d-block text-left specific-y-padding-6 px-3 border text-decoration-none general-button rounded-pill text-925 ${
              notEnableReports
                ? 'action-button-disabled report-button-disabled'
                : 'simple-link-button action-state-hover'
            }`}
            data-tooltip-html={`${
              embargoed ? `You cannot create a report on this ${resourceWord}<br/> while it is under embargo` : ''
            }`}
            data-tooltip-id='general-tooltip'
            disabled={embargoed}
            onClick={async (e) => {
              if (enableReports && isAuthenticated) {
                setIsOpenReportPopup(true);
              } else {
                setIsOpen(true);
              }
            }}
          >
            <span className='icon-document title-h5 d-inline-block-centered specific-right-margin-11 centered-2' />
            Add this {resourceWord} to a report
            {notEnableReports && <span className='icon-padlock ml-2 d-inline-block-centered centered-1' />}
          </button>
        </div>
      )}
      <ReportsPopup isOpen={isOpen} setIsOpen={setIsOpen} />
      <AddUpdatesToReport
        selectedUpdates={[currentNew]}
        isOpen={isOpenReportPopup}
        setIsOpen={setIsOpenReportPopup}
        fromMainList={true}
      />
    </>
  );
};

export default CreateReportFromUpdate;
